module.exports = __webpack_public_path__ + "static/tim.000e865a.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/assets/people/tim.jpg
// module id = 348
// module chunks = 193747675109532